import { http } from '@cap/rzmt-core';

export const getMultiSearchList = <T>(data) => {
  return http.post<T>('tdxcourseservice_querycoursebydimensionclassify', data);
};

interface IGrayTest {
  gray: boolean;
}

export const getGrayTest = (data: { abTestScene?: string; tenant: string; tenantId: number | undefined }) => {
  const { abTestScene = 'courseDetails_PC', tenant, tenantId } = data;
  return http.post<IGrayTest>(
    'tdxxueyuanhomepageservice_getgraytest',
    {
      abTestScene,
    },
    {
      params: {
        tenant,
        tenantId,
      },
    },
  );
};
